import React from "react";
import PropTypes from "prop-types";
import { INDUSTRIES, JOB_TITLE, SENIORITY } from "common/constants/Professions";
import DropDownMenu from "components/v3/dropdown-menu/DropdownMenu";
import GoogleTracking from "services/GoogleTracking";
import Header from "components/v3/header/Header";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import { BUTTON_THEME_WHITE } from "components/v3/primary-button/themes";
import LegalLinks from "components/v3/legal-links/LegalLinks";
import styles from "./styles.module.scss";

class Profession extends React.Component {
    constructor(props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
    }

    componentDidMount() {
        GoogleTracking.setDataLayerFields({
            cd9: "industry",
            cd13: this.props.flow || "register",
            action: "Register"
        });

        this.props.checkProfession();
    }

    _onSubmit(event) {
        const { industry, jobTitle, seniority, updateProfession } = this.props;

        event.preventDefault();
        updateProfession({ industry, jobTitle, seniority });
    }

    render() {
        const {
            industry,
            onIndustryChange,
            jobTitle,
            onJobTitleChange,
            seniority,
            onSeniorityChange,
            bloombergSiteUrl,
            skipIndustryScreen,
            thinking
        } = this.props;

        const title = "Choose your industry";
        const blurb = "Help us deliver more relevant content for you by telling us about yourself.";

        return (
            <div>
                <Header title={ title } />
                <div className={ styles.body }>
                    <span className={ styles.blurb }>{ blurb }</span>
                    <form selectid="form-element-profession-form" className={ styles.form } onSubmit={ this._onSubmit }>
                        <DropDownMenu
                            theme="profession"
                            label="Industry"
                            items={ INDUSTRIES }
                            placeholder="Industry"
                            value={ industry }
                            onValueChange={ onIndustryChange }
                        />
                        <DropDownMenu
                            theme="profession"
                            label="Job Title"
                            items={ JOB_TITLE }
                            placeholder="Job Title"
                            value={ jobTitle }
                            onValueChange={ onJobTitleChange }
                        />
                        <DropDownMenu
                            theme="profession"
                            label="Seniority"
                            items={ SENIORITY }
                            placeholder="Seniority"
                            value={ seniority }
                            onValueChange={ onSeniorityChange }
                        />
                        <div className={ styles.continueButton }>
                            <PrimaryButton text="Continue" thinking={ thinking } />
                        </div>
                    </form>
                    <PrimaryButton
                        text="Skip For Now"
                        theme={ BUTTON_THEME_WHITE }
                        onClick={ skipIndustryScreen }
                    />
                    <LegalLinks bloombergSiteUrl={ bloombergSiteUrl } />
                </div>
            </div>
        );
    }
}

Profession.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired,
    industry: PropTypes.string,
    jobTitle: PropTypes.string,
    seniority: PropTypes.string,
    checkProfession: PropTypes.func.isRequired,
    onIndustryChange: PropTypes.func.isRequired,
    onJobTitleChange: PropTypes.func.isRequired,
    onSeniorityChange: PropTypes.func.isRequired,
    updateProfession: PropTypes.func.isRequired,
    skipIndustryScreen: PropTypes.func.isRequired,
    thinking: PropTypes.string
};

export default Profession;
